module.exports = __webpack_public_path__ + "img/booty.325e3085.svg";